// extracted by mini-css-extract-plugin
export default {"modal":"SendTestsMessageModal-module__modal__1uowa","content":"SendTestsMessageModal-module__content__mNKmo","alert":"SendTestsMessageModal-module__alert__bq6XR"};